module.exports = __webpack_public_path__ + "img/spelling-course-2.6554cbcf.png";